import { Builder, withChildren } from '@builder.io/react';

import ImageContainer from './index';

const ImageContainerWithBuilderChildren = withChildren(ImageContainer);

Builder.registerComponent(ImageContainerWithBuilderChildren, {
  name: 'ImageContainer',
  inputs: [
    {
      name: 'imageMobile',
      type: 'object',
      subFields: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true
        },
        {
          name: 'alt',
          type: 'string',
          required: true
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        }
      ]
    }
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Image',
        options: {
          image:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fac64ee3d7a814bc0852260ed4e5721f9',
          altText: 'metrics',
          aspectRatio: 0.498,
          height: 996,
          width: 2000,
          backgroundSize: 'contain',
          backgroundPosition: 'top',
          fitContent: true,
          lockAspectRatio: true
        }
      }
    }
  ]
});
